module.exports = __webpack_public_path__ + "img/currency-pound-circle.9c858c0b.svg";